import { defineComponent, computed, openBlock, createBlock, resolveDynamicComponent, normalizeClass, withCtx, createElementVNode, createElementBlock, createVNode, createCommentVNode, renderSlot, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$1 from '../Icon/Icon.vue.mjs';
import _sfc_main$2 from '../Loader/Loader.vue.mjs';
import { useButtonStyles } from './useButtonStyles.mjs';

const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { key: 2 };
const _hoisted_4 = {
  key: 0,
  class: "absolute",
  style: { "top": "50%", "left": "50%", "transform": "translate(-50%, -50%)" }
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    as: { default: "button" },
    size: { default: "large" },
    label: {},
    variant: { default: "solid" },
    state: { default: "default" },
    padding: { default: "default" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: {},
    leadingIcon: {},
    trailingIcon: {}
  },
  setup(__props) {
    const props = __props;
    const { base, variants, disabled, validateSize, validatePadding } = useButtonStyles();
    const buttonSize = computed(() => props.size);
    const buttonPadding = computed(() => props.padding);
    validateSize(props.variant, buttonSize.value);
    validatePadding(props.variant, buttonPadding.value);
    const shouldBeDisabled = computed(() => props.disabled || props.loading);
    const classes = computed(() => {
      return [
        base,
        props.disabled && !props.loading && disabled,
        variants[props.variant]?.class || "",
        variants[props.variant]?.sizes[buttonSize.value] || "",
        variants[props.variant]?.padding[props.padding][buttonSize.value] || "",
        variants[props.variant]?.states[props.state][buttonSize.value] || ""
      ];
    });
    const loaderSize = computed(() => {
      return variants[props.variant]?.loaderSize[buttonSize.value];
    });
    const iconType = computed(() => {
      if (buttonSize.value === "large") {
        return "outline";
      }
      if (buttonSize.value === "small") {
        return "micro";
      }
      return "mini";
    });
    const trailingIconType = computed(() => "mini");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), {
        type: _ctx.as === "button" ? "button" : null,
        class: normalizeClass(classes.value),
        disabled: shouldBeDisabled.value
      }, {
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(["flex items-center gap-1", {
              invisible: _ctx.loading
            }])
          }, [
            _ctx.leadingIcon ? (openBlock(), createElementBlock("span", _hoisted_1, [
              createVNode(_sfc_main$1, {
                name: _ctx.leadingIcon,
                type: trailingIconType.value
              }, null, 8, ["name", "type"])
            ])) : createCommentVNode("", true),
            _ctx.icon ? (openBlock(), createElementBlock("span", _hoisted_2, [
              createVNode(_sfc_main$1, {
                name: _ctx.icon,
                type: iconType.value
              }, null, 8, ["name", "type"])
            ])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "default", {}, () => [
              createTextVNode(toDisplayString(_ctx.label), 1)
            ]),
            _ctx.trailingIcon ? (openBlock(), createElementBlock("span", _hoisted_3, [
              createVNode(_sfc_main$1, {
                name: _ctx.trailingIcon,
                type: trailingIconType.value
              }, null, 8, ["name", "type"])
            ])) : createCommentVNode("", true)
          ], 2),
          _ctx.loading ? (openBlock(), createElementBlock("span", _hoisted_4, [
            createVNode(_sfc_main$2, { width: loaderSize.value }, null, 8, ["width"])
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["type", "class", "disabled"]);
    };
  }
});

export { _sfc_main as default };
